/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsEpssScoreQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsEpssScoreQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsEpssScoreQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsEpssScoreQueryOperator>): AppSecopsEpssScoreQueryOperator {
        let obj = Object.assign(new AppSecopsEpssScoreQueryOperator(), model);
        AppSecopsEpssScoreQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsEpssScoreQueryOperator>): AppSecopsEpssScoreQueryOperator {
        if (!model) return null;
        return AppSecopsEpssScoreQueryOperator.newInstance(<AppSecopsEpssScoreQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsEpssScoreQueryOperator) {
        if (!obj) return;

        models.AppSecopsEpssScoreQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsEpssScoreQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsEpssScoreQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.epss_score === undefined) {
            this.epss_score = 0;
        }
    }

    /**
     * EPSS score associated with the vulnerability
     */
    epss_score: number;

}
